import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
const state = {
    user: null,
    token: Cookies.get('token'),
    userRoleUpdateDialog: false,
    expires_in: Cookies.get('expires'),
    userId: 0
}

// getters
const getters = {
    user: state => state.user,
    token: state => state.token,
    isAuth: state => !!state.user,
    check: state => state.user !== null,
    expires_in: state => state.expires_in,
    userRoleUpdateDialog: state => state.userRoleUpdateDialog,
    userId : state => state.userId,
}

// mutations
const mutations = {
    [types.SAVE_TOKEN] (state, { token, remember }) {
        state.token = token
        Cookies.set('expires',remember)
        state.expires_in = remember
        Cookies.set('token', token, { expires: remember})
    },

    [types.FETCH_USER_SUCCESS] (state, user) {
        state.user = user.data
    },

    [types.FETCH_USER_FAILURE] (state) {
        state.token = null
        Cookies.remove('token')
    },

    [types.LOGOUT] (state) {
        state.user = null
        state.token = null

        Cookies.remove('token')
    },

    [types.UPDATE_USER] (state, { user }) {
        state.user = user
    },

    userRoleUpdateDialog (state, payload) {
        state.userRoleUpdateDialog = payload
    },

    userId (state, payload) {
        state.userId = payload
    },
}

// actions
const actions = {
    saveToken ({ commit }, payload) {
        commit(types.SAVE_TOKEN, payload)
    },

    async fetchUser ({ commit }) {
        try {
            const response = await axios.get('/user')
            const { data } = response

            commit(types.FETCH_USER_SUCCESS, data)
        } catch (e) {
            commit(types.FETCH_USER_FAILURE)
        }
    },

    updateUser ({ commit }, payload) {
        commit(types.UPDATE_USER, payload)
    },

    async logout ({ commit }) {
        try {
            await axios.post('/api/admin/auth/logout')
        } catch (e) {
            console.log(e);
        }

        commit(types.LOGOUT)
    },

    async fetchOauthUrl (ctx, { provider }) {
        const { data } = await axios.post(`/api/oauth/${provider}`)

        return data.url
    }
}
export default {
    state,
    getters,
    mutations,
    actions,
};
